module.exports = __webpack_public_path__ + "images/videoCaseStudy-nivea-solution-videoPoster.jpg?h=473dcac795b9fd3c95c1e9ed03db65c5";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-solution-videoPoster.jpg
// module id = 2119
// module chunks = 12 15